import { Avatar } from "@/config/antd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const CanvassCard = ({ id, householdName, address, status = "Pending" }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/dashboard/canvass/${id}`);
  };

  // Get initial for avatar
  const getInitial = (name) => {
    return name?.charAt(0) || "H";
  };

  // get status color
  const getStatusColor = (status) => {
    status = status.toLowerCase();
    switch (status) {
      case "pending":
        return "text-warning";
      case "complete":
        return "text-green";
      case "failed":
        return "text-danger";
      default:
        return "text-secondary";
    }
  };

  return (
    <div
      className="flex justify-between p-2 mb-4 text-left bg-[var(--header-bg)] cursor-pointer lg:mb-0 rounded-xl lg:border-transparent lg:bg-secondary"
      onClick={handleCardClick}>
      <div className="flex items-center gap-4">
        <Avatar
          size={56}
          style={{
            backgroundColor: "#0F75BC",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            width: "56px",
            height: "56px",
            lineHeight: "56px",
            textAlign: "center",
            flexShrink: 0,
          }}>
          {getInitial(householdName)}
        </Avatar>
        <div className="flex flex-col gap-1">
          <h3 className="text-base text-black font-bold truncate max-w-[200px]">
            {householdName}
          </h3>
          <span className="text-small dark-mode-text">{address}</span>
          <span className="text-small lg:hidden">
            <span className={`${getStatusColor(status)}`}>{status}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

CanvassCard.propTypes = {
  id: PropTypes.string,
  householdName: PropTypes.string,
  address: PropTypes.string,
  members: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.string,
};

export default CanvassCard;
